import { URLS } from './urls'

export const getRoutes = isSelectClaimEnabled => {
  return {
    [URLS.passwordless.identify.path()]: {
      route: URLS.passwordless.identify.path(),
      next: URLS.passwordless.accessCode.path(),
    },
    [URLS.passwordless.accessCode.path()]: {
      route: URLS.passwordless.accessCode.path(),
      next: URLS.dashboard(),
      prev: URLS.passwordless.identify.path(),
    },
    [URLS.passwordless.review.path()]: {
      route: URLS.passwordless.review.path(),
      next: URLS.leadReview(),
    },
    [URLS.password.identify.path()]: {
      route: URLS.password.identify.path(),
      next:
        isSelectClaimEnabled === 'on'
          ? URLS.password.selectClaim.path()
          : URLS.password.enter.path(),
      prev:
        isSelectClaimEnabled === 'on'
          ? null
          : URLS.passwordless.identify.path(),
    },
    [URLS.password.selectClaim.path()]: {
      route: URLS.password.selectClaim.path(),
      next: URLS.password.accessCode.path(),
      prev: URLS.password.identify.path(),
    },
    [URLS.password.accessCode.path()]: {
      route: URLS.password.accessCode.path(),
      next: URLS.dashboard(),
      prev: URLS.password.selectClaim.path(),
    },
    [URLS.password.enter.path()]: {
      route: URLS.password.enter.path(),
      next: URLS.dashboard(),
      prev:
        isSelectClaimEnabled === 'on'
          ? URLS.password.selectClaim.path()
          : URLS.password.identify.path(),
    },
    [URLS.signup.identify.path()]: {
      route: URLS.signup.identify.path(),
      next: URLS.signup.document.path(),
      prev:
        isSelectClaimEnabled === 'on'
          ? URLS.password.identify()
          : URLS.passwordless.identify.path(),
    },
    [URLS.signup.document.path()]: {
      route: URLS.signup.document.path(),
      next: URLS.signup.email.path(),
      prev: URLS.signup.identify.path(),
    },
    [URLS.signup.email.path()]: {
      route: URLS.signup.email.path(),
      next: URLS.signup.accessCode.path(),
      prev: URLS.signup.document.path(),
    },
    [URLS.signup.accessCode.path()]: {
      route: URLS.signup.accessCode.path(),
      next: URLS.dashboard(),
      prev: URLS.signup.email.path(),
    },
    [URLS.recovery.index.path()]: {
      route: URLS.recovery.index.path(),
    },
    [URLS.recovery.emailSend.path()]: {
      route: URLS.recovery.emailSend.path(),
      next: URLS.password.identify.path(),
    },
    [URLS.dashboard()]: {
      auth: true,
      external: true,
      route: URLS.dashboard(),
    },
    [URLS.leadReview()]: {
      auth: true,
      external: true,
      route: URLS.leadReview(),
    },
    [URLS.singleAuth()]: {
      route: URLS.singleAuth(),
      next: URLS.dashboard(),
      prev: URLS.passwordless.identify.path(),
    },
    [URLS.successCreatePassword()]: {
      route: URLS.successCreatePassword(),
      next: URLS.password.identify.path(),
    },
    [URLS.invalidCreatePassword()]: {
      route: URLS.invalidCreatePassword(),
      next: URLS.password.identify.path(),
    },
    [URLS.invalidRecoveryPassword()]: {
      route: URLS.invalidRecoveryPassword(),
      next: URLS.password.identify.path(),
    },
    [URLS.createPassEmailSend()]: {
      route: URLS.createPassEmailSend(),
      next: URLS.passwordless.identify.path(),
    },
    [URLS.newPassword()]: {
      route: URLS.newPassword(),
      next: URLS.newPassword.validate.path(),
      prev: URLS.password.identify.path(),
    },
    [URLS.newPassword.validate.path()]: {
      route: URLS.newPassword.validate.path(),
      next: URLS.password.identify.path(),
      prev: URLS.newPassword(),
    },
    [URLS.createNewPassword()]: {
      route: URLS.createNewPassword(),
      next: URLS.createNewPassword.validate.path(),
      prev: URLS.password.identify.path(),
    },
    [URLS.createNewPassword.validate.path()]: {
      route: URLS.createNewPassword.validate.path(),
      next: URLS.password.identify.path(),
      prev: URLS.createNewPassword(),
    },
  }
}
